export default function ReviewShuffle () {
  const WRAPPERS = document.querySelectorAll('.shuffle-grid')

  if (WRAPPERS.length > 0) {
    for (let i = 0; i < WRAPPERS.length; i++) {
      const WRAPPER = WRAPPERS[i]
      new ShuffleReviews(WRAPPER)
    }
  }
}

class ShuffleReviews {
  constructor(WRAPPER) {
    this.WRAPPER = WRAPPER
    this.firstSection = this.WRAPPER.querySelector('.review-wrap__column-one')
    this.secondSection = this.WRAPPER.querySelector('.review-wrap__column-two-first')
    this.thirdSection = this.WRAPPER.querySelector('.review-wrap__column-two-second')

    setInterval(() => {
      this.shuffleReview(this.firstSection)

      setTimeout(() => {
        this.shuffleReview(this.secondSection)
      }, 2000)

      setTimeout(() => {
        this.shuffleReview(this.thirdSection)
      }, 4000)
    }, 8000)
  }

  shuffleReview(section) {

    if (section) {
      const ACTIVE_REVIEW = section.querySelector('.review-card.show')
      const HIDDEN_REVIEWS = section.querySelectorAll('.review-card.hide')

      this.changeReview(ACTIVE_REVIEW, HIDDEN_REVIEWS)
    }
  }

  changeReview(ACTIVE_REVIEW, HIDDEN_REVIEWS) {
    if (HIDDEN_REVIEWS.length > 0) {
      const randomReview = HIDDEN_REVIEWS[Math.floor(Math.random() * HIDDEN_REVIEWS.length)]

      if (ACTIVE_REVIEW) {
        this.hideReview(ACTIVE_REVIEW)
      }
      this.showReview(randomReview)

    }
  }

  hideReview(ACTIVE_REVIEW) {
    ACTIVE_REVIEW.classList.add('fade-out')

    setTimeout(() => {
      ACTIVE_REVIEW.classList.remove('show')
      ACTIVE_REVIEW.classList.add('hide')
      ACTIVE_REVIEW.classList.remove('fade-out')
    }, 1000)
  }

  showReview(randomReview) {
    setTimeout(() => {
      randomReview.classList.add('fade-in')
      randomReview.classList.add('show')
      randomReview.classList.remove('hide')
    }, 1000)

    setTimeout(() => {
      randomReview.classList.remove('fade-in')
    }, 2000)
  }
}
